import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const updateResellerBanned = async (reseller, ban, context = {}) => {
  try {
    const identity = typeof reseller === 'string'
      ? { email: reseller }
      : {
          resellerId:
            reseller?.resellerId ||
            (reseller?.id && !reseller.id.includes('@') ? reseller.id : undefined),
          email: reseller?.email,
        };
    const updateResellerBannedFn = httpsCallable(functions, 'updateResellerBannedV2');
    const result = await updateResellerBannedFn({
      ...identity,
      ban,
      ...context,
      requestedApp: context.requestedApp || 'dealership_web',
    });
    return {
      success: result.data.success === 'yes',
      bannedScopes: result.data.bannedScopes || [],
      banned: result.data.banned || [],
    };
  } catch (error) {
    console.error('Error actualizando banned:', error);
    notifyPermissionDenied(error);
    return { success: false, bannedScopes: [], banned: [] };
  }
};
